import React, { Component } from 'react';
import axios from "axios"
// import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';

class TakePicture extends React.Component {
  constructor(props) {
    super(props);
    this.onTakePhoto = this.onTakePhoto.bind(this)

    this.state = {
      imagesData: [],
      images: []
    };
  }
  onTakePhoto (dataUri) {
    this.setState({imagesData: [...this.state.imagesData,dataUri]})
    axios.post("/api/v1/experts/app/sortie/uploadCompteurs",{
      id: this.props.sortie,
      data: dataUri}).then((data)=>{
      this.props.reloadImages()
    })
  }
  render() {
      return(
        <div>
        <Camera
            onTakePhoto = { (dataUri) => { this.onTakePhoto(dataUri); } }
            idealFacingMode = {FACING_MODES.ENVIRONMENT}

            />
        </div>
        )

  }
}



export default TakePicture
